import * as React from 'react';
import { ArticleHeading4, UIText1 } from '@cian/ui-kit/typography';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';
import { IFlatOffers } from '../../../../types/offers';
import { HoveredLink } from '../../../HoveredLink';
import { OffersLayoutList } from '../OffersLayoutList';

interface IOffersRowProps extends IFlatOffers {
  displayHouseName?: boolean;
  onRoomTypeLinkClick(label: string): void;
  onOfferLinkClick(offerId: number, gaLabel: string): void;
  onOffersQuantityLinkClick(roomType: string): void;
}

export function OffersRow({
  roomTypeDisplay,
  totalAreaMinDisplay,
  price2Range,
  fromDeveloperPropsCountDisplay,
  fromDeveloperPropsCount,
  offersUrl,
  layouts,
  displayHouseName,
  roomType,
  onRoomTypeLinkClick,
  onOfferLinkClick,
  onOffersQuantityLinkClick,
}: IOffersRowProps) {
  const [expanded, changeExpandedState] = React.useState(false);
  const toggleExpand = React.useCallback(() => {
    changeExpandedState(!expanded);
    onOffersQuantityLinkClick(roomType);
  }, [expanded]);
  const ArrowIcon = expanded ? IconActionChevronUpSmall16 : IconActionChevronDownSmall16;

  return (
    <div className={styles['container']}>
      <div className={styles['row']}>
        <div className={styles['room-type']}>
          <HoveredLink
            url={offersUrl}
            childNode={ArticleHeading4}
            as="h4"
            color="decorative-theme-dark"
            data-testid="OffersRowRoomType"
            onClick={() => onRoomTypeLinkClick(roomType)}
          >
            {roomTypeDisplay}
          </HoveredLink>
        </div>
        <div>
          <UIText1 color="gray60_100">{totalAreaMinDisplay}</UIText1>
        </div>
        <div className={styles['price']} data-testid="OffersRowPrice">
          <UIText1 color="text-primary-default">{price2Range}</UIText1>
        </div>
        <div className={styles['props-count']} data-testid="OffersRowPropsCount">
          <div onClick={toggleExpand}>
            <UIText1 color="text-main-default">{fromDeveloperPropsCountDisplay}</UIText1>
            <div className={styles['arrow']}>
              <ArrowIcon color="icon-main-default" />
            </div>
          </div>
        </div>
      </div>
      <OffersLayoutList
        expanded={expanded}
        offersUrl={offersUrl}
        layouts={layouts}
        displayHouseName={displayHouseName}
        fromDeveloperPropsCount={fromDeveloperPropsCount}
        onAllOffersLinkClick={() => onRoomTypeLinkClick(roomType)}
        onOfferLinkClick={onOfferLinkClick}
      />
    </div>
  );
}
